const values = [
  "dailytrial_chest",
  "dailytrial_chest_open",
  "dark_chest",
  "dark_chest_open",
  "event_chest",
  "event_chest_open",
  "frost_tower_chest",
  "frost_tower_chest_open",
  "gold_chest",
  "gold_chest_open",
  "hero_chest_t1",
  "hero_chest_t1_open",
  "hero_chest_t2",
  "hero_chest_t2_open",
  "hero_chest_t3",
  "hero_chest_t3_open",
  "hero_chest_t4",
  "hero_chest_t4_open",
  "hero_chest_t5",
  "hero_chest_t5_open",
  "hero_chest_t6",
  "hero_chest_t6_open",
  "light_chest",
  "light_chest_open",
  "light_house_tower_chest",
  "light_house_tower_chest_open",
  "nature_chest",
  "nature_chest_open",
  "physic_chest",
  "physic_chest_open",
  "premium_chest",
  "premium_chest_open",
  "spell_chest_t1",
  "spell_chest_t1_open",
  "spell_chest_t2",
  "spell_chest_t2_open",
  "spell_chest_t3",
  "spell_chest_t3_open",
  "spell_chest_t4",
  "spell_chest_t4_open",
  "spell_chest_t5",
  "spell_chest_t5_open",
  "spell_chest_t6",
  "spell_chest_t6_open",
  "tower_chest_t1",
  "tower_chest_t1_open",
  "tower_chest_t2",
  "tower_chest_t2_open",
  "tower_chest_t3",
  "tower_chest_t3_open",
  "tower_chest_t4",
  "tower_chest_t4_open",
  "tower_chest_t5",
  "tower_chest_t5_open",
  "tower_chest_t6",
  "tower_chest_t6_open",
  "water_chest",
  "water_chest_open",
  "wood_chest",
  "wood_chest_open",
];
export default values;
